import { findDOMNode } from "react-dom";
import { Textarea as BaseTextArea } from "react-ui";
import React from "react";

import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export const PopupTextAreaTestPageObject = (
    value: undefined | string,
    textarea: React.RefObject<BaseTextArea>,
    container: React.RefObject<HTMLDivElement>,
    onChange: (nextValue: string) => void
) => ({
    getType: () => "PopupTextArea",

    getValue: () => value,

    setValue: (currentValue: string): void => {
        onChange(currentValue);
    },

    isFocused: () => {
        if (textarea.current == undefined) {
            return false;
        }
        const textAreaElement = toHtmlElementOrNull(findDOMNode(textarea.current));
        if (textAreaElement == undefined) {
            return false;
        }
        const textareaElement = textAreaElement.querySelector("textarea");

        return document.activeElement === textareaElement;
    },

    isInView: (): boolean => {
        if (container.current == undefined) {
            return false;
        }
        const rect = container.current.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= document.documentElement.clientHeight &&
            rect.right <= document.documentElement.clientWidth
        );
    },
});
